<template>
          <div class="row list_view">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

              <template v-if="cocurricularReqs && cocurricularReqs.length > 0">
                <div class="row result_row" v-for="(career, index) in cocurricularReqs">

                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 thumbnail_section">
                      <div @click.stop="launch(career)" class="thumbnail_container ace_sec">
                        <div class="thumbnail_img" v-if="career.thumbnailURI">
                          <img v-bind:src="career.thumbnailURI" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
                        </div>
                        <div class="thumbnail" v-else>
                          <div class="txt_bx" v-html="setTitleInitials(career.title)"></div>
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-6 col-lg-6 col-md-5 col-sm-8 entity_detail_section">
                      <div class="row">
                        <div class="col-12 title_row">
                          <span @click.stop="launch(career)" class="title ace_sec_txt" :id="'entityName_' + index" :aria-label="career.title">{{career.title}}</span>

                          <b-popover :target="'entityName_' + index" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer_' + index">
                            <div class="title_container">
                              {{career.title}}
                            </div>
                          </b-popover>
                          <div :id="'entityNameContainer_' + index" class="title_container_popup"></div>

                        </div>

                        <div class="col-12 description ace_sec_txt" :id="'entityDesc_' + index" v-if="career.description">
                           <span class="desc_txt">{{ career.description }}</span>
                        </div>
                      </div>
                    </div>


                    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-12 other_info">
                      <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row" v-if="(career.entityType === 'CLUB')">
                          <div class="info_link">
                            <a href="javascript://" @click="launch(career)" style="color: #157099;">join the club</a>
                          </div>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row" v-if="(career.entityType === 'JOB')">
                          <div class="info_link">
                            <a href="javascript://" @click="launch(career)" style="color: #157099;">apply for job</a>
                          </div>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row" v-if="(career.entityType === 'EVENT')">
                          <div class="info_link">
                            <a href="javascript://" @click="launch(career)" style="color: #157099;">register for event</a>
                          </div>
                        </div>
                      <!--    
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
                          <div class="info_title">alumni reports</div>
                        </div>
                      -->
                      </div>
                    </div>

                  </div>
                </template>
              </div> 
          </div> 
</template>
<script>
  import { mapActions, mapState } from 'vuex'
  import _ from 'lodash'
  import CourseProgressBar from './CourseProgressBar'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'program-cocurricular',
    props: ['pathwayId'],
    components: {
      CourseProgressBar
    },
    data () {
      return {
        selfReportedCourseMap: {},
        cocurricularReqs: [],
        userId: localStore.getItem('userid'),
        username: localStore.getItem('userFullName'),
        isCoursesLoaded: false,
        clickedCourse: '',
        selectedStatus: '',
        courseStatusMap: {
          0: 'Not Started',
          1: 'In Progress',
          2: 'Completed',
          7: 'Couldn\'t Complete'
        },
        courseStatusBackgroundMap: {
          0: 'status-not-started',
          1: 'status-in-progress',
          2: 'status-completed',
          7: 'status-not-completed'
        }
      }
    },
    mounted () {
      this.showLoader()
      this.loadCourseList()
    },
    methods: {
      ...mapActions([
        'loadProgramCocurricular',
        'updateProgramCourseStatus',
        'navigateUserToCourseDashboard'
      ]),
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      setThumbnailTitle (course) {
        return course.programCode
      },
      async updateCourseStatus (streamId, status) {
    		let data = {
          uuid: streamId,
          status: status
        }
        this.updateProgramCourseStatus(data).then(result => {
        	this.resetPage()
        })
      },
      async loadCourseList () {
        this.loadProgramCocurricular(this.pathwayId).then(result => {
          this.selfReportedCourseMap = _.groupBy(result, 'parentId')
          this.cocurricularReqs = result;
          this.totalElements = result.length
          this.hideLoader()
          this.selected = [],
          this.isCoursesLoaded = true
        })
      },
      resetPage () {
        this.loadCourseList()
      },    
      launch (object) {
        if(object.externalURI){
          window.open(object.externalURI, '_blank')
        }
      },    
      setTitleInitials (entityTitle) {
        if (!entityTitle) {
          return ' '
        }
        let getTitleInitials = entityTitle.match(/\b(\w)/g)
        return getTitleInitials.join('')
      }


    }
  }
</script>

<style>
  .title-txt {
    color: #fff;
    margin-top: 3px;
    font-weight: 500;
    text-align: center;
  }
  .info_link {
      text-align: left;
  }
  div[id^="courseStatusPopup-"] .popover {
    transform: translate3d(-8px, 20px, 0px) !important;
    max-width: 220px !important;
    width: 220px !important;
    height: 225px !important;    
    margin-top: 15px;
  }

  div[id^="courseStatusPopup-"] .popover .arrow {
    display: none !important;    
  }

  .form-check-input {
    top: 12px;
    cursor: pointer;
  }  

  .status-not-started {
    background: #b4b4b4 !important;
  }

  .status-in-progress {
    background: #dd9623 !important;
  }

  .status-completed {
    background: #0a7714 !important;
  }

  .status-not-completed {
    background: #f40909 !important;
  }
</style>


// WEBPACK FOOTER //
// src/app/transfer/components/ProgramCocurricular.vue